/*------------------------------------------------------------------------------
   About      : Named capabilities — reusable compound permission requirements

   Single permissions are used raw (BFF_FEATURES.X.Y); only requirements that
   combine several actions AND are reused across components get a name here,
   so anyOf/allOf sets are declared once and never drift between call sites.

   Copyright (c) 2026 Bidgely. All rights reserved.
------------------------------------------------------------------------------*/
import { BFF_FEATURES }          from './PermissionCatalog'
import { PermissionRequirement } from './accessControl'

export const CAPABILITIES = {

  /**
   * Persist WYSIWYG editor changes — the save flow writes configs AND
   * strings. These calls hit proxypulse's `/v1/cx/*` routes (see
   * cxEditorAPI.ts), gated by its own feature RBAC.
   */
  WYSIWYG_SAVE : {
    allOf : [
      BFF_FEATURES.CX.SAVE,
      BFF_FEATURES.CX.SAVE_STRINGS,
    ],
  },

  /** Copy edited section to other templates — save + strings + export-audit complete */
  WYSIWYG_COPY : {
    allOf : [
      BFF_FEATURES.CX.SAVE,
      BFF_FEATURES.CX.SAVE_STRINGS,
      BFF_FEATURES.CX.COMPLETE_OPERATION_AUDIT,
    ],
  },

} as const satisfies Record<string, PermissionRequirement>
